export default __webpack_public_path__ + "static/Logo-Trans-Square-cf7142102ee6ce11805b588a25bd844f.png";